module.exports = require("qrcode");